import { Header } from '../common/Header';
import Card from '@mui/material/Card';
import TableGrid from '../table-grid/TableGrid';
import { EndPoints } from '../../axios/endPoints';
import { GridColDef } from '@mui/x-data-grid';
import { Button, Grid, IconButton, Tooltip } from '@mui/material';
import moment from 'moment';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { handleRefreshSelectedMLCreatorTable, handleTrainNewModel } from '../../store/mlcreator-slice/mlcreator';
import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import TrainNewModelDialog from './TrainNewModelDialog';
import SuccessfulTrainingDetails from './SuccessfulTrainingDetails';
import TrainingModelDetails from './TrainingModelDetails';
import DeleteTrainingModelDialog from './DeleteTrainingModelDialog';
import RedirectIconButton from '../common/RedirectIconButton';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import FailedTrainingDialog from './FailedTrainingDialog';
import RefreshIcon from '@mui/icons-material/Refresh';
import Old_TrainingStatusActions from './old_TrainingStatusActions';

interface MLCreatorProps { };

const Old_SelectedMLCreator = React.forwardRef<HTMLDivElement, MLCreatorProps>((props, ref) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const selectedCreatorRow = useAppSelector((state: RootState) => state.mlcreator.selectedCreatorRow);
    const refreshSelectedMLCreatorTable = useAppSelector((state: RootState) => state.mlcreator.refreshSelectedMLCreatorTable);

    const memoizedSelectedCreatorRow = useMemo(() => selectedCreatorRow, [selectedCreatorRow]);

    const selecetdMLCreatorColumns: GridColDef[] = useMemo(() => [
        { field: 'id', headerName: t('SELECTED_CREATOR_ID_FIELD') },
        { field: 'name', headerName: t('SELECTED_CREATOR_MODEL_NAME_FIELD'), minWidth: 300 },
        {
            field: 'trainingDate', headerName: t('SELECTED_CREATOR_TRAINING_DATE_FIELD'), renderCell: (params) => {
                return moment.utc(params.value).local().format('DD/MM/YYYY HH:mm')
            }, minWidth: 200
        },
        {
            field: 'selectedModelTypeString', headerName: t('SELECTED_CREATOR_MODEL_TYPE_FIELD'), renderCell: (params) => {
                return t(`${params.value}`)
            }, minWidth: 200
        },
        {
            field: 'selectedModelSubtype', headerName: t('SELECTED_CREATOR_MODEL_SUBTYPE_FIELD'), renderCell: (params) => {
                return t(`${params.value}`)
            }, minWidth: 250
        },
        { field: 'testingResultsCount', headerName: t('SELECTED_CREATOR_TESTING_RESULTS_FIELD'), minWidth: 150 },
        {
            field: 'actions', headerName: t('SELECTED_CREATOR_ACTIONS_FIELD'), minWidth: 300, renderCell: (params) => {
                return (<Old_TrainingStatusActions params={params} dispatch={dispatch} t={t} />)
            }
        }
    ], [dispatch, t])

    return (
        <React.Fragment>
            {memoizedSelectedCreatorRow ?
                <Card style={{ marginTop: '5px' }} ref={ref}>
                    <Header
                        title={t('SELECTED_CREATOR_ROW', { name: memoizedSelectedCreatorRow.name })}
                        helperIcon={
                            <RedirectIconButton to={'/help/3'} className="helper-icon" >
                                <ContactSupportIcon />
                            </RedirectIconButton>
                        }
                    />
                    <Grid container p={2} spacing={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Grid item display="flex" justifyContent="space-between">
                            <Button
                                onClick={() => { dispatch(handleTrainNewModel({ isOpen: true })) }}
                                variant='contained'
                                className='button-color'
                                size='small'
                            >
                                {t('TRAIN_NEW_MODEL_BUTTON_TEXT')}
                            </Button>
                            <Tooltip title={t('REFRESH_TABLE_BUTTON_TOOLTIP')}>
                                <IconButton onClick={() => dispatch(handleRefreshSelectedMLCreatorTable())}>
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item sx={{ width: '100%', overflowY: 'auto' }}>
                            <TableGrid
                                baseURL={EndPoints.ML_CREATOR_GET_TRAINING_MODELS}
                                aditionalQueryParams={{
                                    datasetId: memoizedSelectedCreatorRow.id
                                }}
                                columns={selecetdMLCreatorColumns}
                                sortColumns={[{ field: 'id', sort: 'asc' }]}
                                refresh={refreshSelectedMLCreatorTable}
                                disableRowSelection
                                tableHeight={500}
                                rowHeight={35}
                                columnHeaderHeight={40}
                            />
                        </Grid>
                    </Grid>
                    <TrainNewModelDialog />
                    <SuccessfulTrainingDetails />
                    <TrainingModelDetails />
                    <DeleteTrainingModelDialog />
                    <FailedTrainingDialog />
                </Card>
                : ''}
        </React.Fragment>
    )
});

export default React.memo(Old_SelectedMLCreator);